import {dateComparator, sortTimes} from '../../../utils/table.util';
export const columnHeaders = {
    visitsColumnHeaders (options, showDetails = false) {
        const leadingHeaders = [
            {
                headerName: 'customer',
                field: 'customer',
                editable: false
            },
            {
                headerName: 'entity' ,
                field: 'entity',
                editable: false
            },
            {
                headerName: 'date',
                field: 'date',
                editable: false,
                maxWidth: 100
            },
            {
                headerName: 'start time',
                field: 'startTime',
                editable: false,
                maxWidth: 80,
                comparator: sortTimes
            },
            {
                headerName: 'end time',
                field: 'endTime',
                editable: false,
                maxWidth: 80,
                comparator: sortTimes
            },
            {
                headerName: 'duration',
                valueGetter: (params) => {
                  return `${params.data.duration} min`;
                },
                editable: false,
                maxWidth: 80
            },
            {
                headerName: 'spots',
                field: 'spots',
                editable: false
            },
            {
                headerName: 'license plate' ,
                field: 'licensePlate',
                editable: false,
                maxWidth: 100
            },
            {
                headerName: 'trailer plate' ,
                field: 'trailerPlate',
                editable: false,
                maxWidth: 100
            }]

        const closingHeaders = [
            {
                headerName: 'User',
                valueGetter: (params) => {
                    return params.data.userCreated
                },
                editable: false,
            },
            {
                headerName: 'status',
                editable: false,
                maxWidth: 100,
                valueGetter: (params) => {
                    if (params.data.status === 'Accepted') {
                        if (params.data.isDelayed) {
                            return 'Delayed'
                        }
                    }
                    return params.data.status;
                }
            }
        ]

        const optionHeaders = options.map((option) => {
            return {
                headerName: option.value,
                valueGetter: (params) => {
                    return params.data.options.find(o => o.id === option.id)?.value ?? undefined
                },
                editable: false,
            }
        })

        const detailHeaders = showDetails ? [
            {
                headerName: 'Vehicle Arrival date',
                field: 'vehicleArrivalDate',
                editable: false,
                minWidth: 150
            },
            {
                headerName: 'Vehicle Departure date',
                field: 'vehicleDepartureDate',
                editable: false,
                minWidth: 150
            },
            {
                headerName: 'Dock Arrival date',
                field: 'dockArrivalDate',
                editable: false,
                minWidth: 150
            },
            {
                headerName: 'Dock Departure date',
                field: 'dockDepartureDate',
                editable: false,
                minWidth: 150
            }
        ] : []

        const handlingHeaders = showDetails && process.env.VUE_APP_HIDE_HANDLING === 'false' ? [
            {
                headerName: 'Start Handling',
                field: 'startHandlingDate',
                editable: false,
                minWidth: 120
            },
            {
                headerName: 'Stop Handling',
                field: 'stopHandlingDate',
                editable: false,
                minWidth: 120
            }
        ] : []

        return [...leadingHeaders, ...optionHeaders, ...detailHeaders, ...handlingHeaders, ...closingHeaders]
    }
}
